import { EnvironmentType } from '../schema/environment.enum';

/**
 * The public Talbinah marketing website (talbinah.net) — a different host than
 * the portal app itself ({@link HOST}) or the API ({@link API_URL}). Every
 * hardcoded `https://talbinah.net` link/asset in the app (FAQ, terms, privacy,
 * pharmacy, rating, referral, fallback images, canonical/OG meta) must resolve
 * through this map instead, so it points at the matching website per environment.
 */
export const WEBSITE_URL: Record<EnvironmentType, string> = {
  [EnvironmentType.LOCAL]: 'https://dev.talbinah.net',
  [EnvironmentType.IN_MEMORY]: 'https://dev.talbinah.net',

  [EnvironmentType.DEV]: 'https://dev.talbinah.net',
  [EnvironmentType.TEST]: 'https://test.talbinah.net',
  [EnvironmentType.RE_DESIGN]: 'https://redesign.talbinah.net',

  [EnvironmentType.STAGING]: 'https://staging.talbinah.net',
  [EnvironmentType.UAT]: 'https://uat.talbinah.net',

  [EnvironmentType.LIVE]: 'https://talbinah.net',
  [EnvironmentType.PRODUCTION]: 'https://talbinah.net',
};
